export default "__VITE_ASSET__BuV6JT7Y__"